var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg858Ab(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-hourglass"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.33333 13.3333H10.6667V11.3333C10.6667 10.6 10.4056 9.97222 9.88333 9.45C9.36111 8.92778 8.73333 8.66667 8 8.66667C7.26667 8.66667 6.63889 8.92778 6.11667 9.45C5.59444 9.97222 5.33333 10.6 5.33333 11.3333V13.3333ZM8 7.33333C8.73333 7.33333 9.36111 7.07222 9.88333 6.55C10.4056 6.02778 10.6667 5.4 10.6667 4.66667V2.66667H5.33333V4.66667C5.33333 5.4 5.59444 6.02778 6.11667 6.55C6.63889 7.07222 7.26667 7.33333 8 7.33333ZM2.66667 14.6667V13.3333H4V11.3333C4 10.6556 4.15833 10.0194 4.475 9.425C4.79167 8.83056 5.23333 8.35556 5.8 8C5.23333 7.64444 4.79167 7.16944 4.475 6.575C4.15833 5.98056 4 5.34444 4 4.66667V2.66667H2.66667V1.33333H13.3333V2.66667H12V4.66667C12 5.34444 11.8417 5.98056 11.525 6.575C11.2083 7.16944 10.7667 7.64444 10.2 8C10.7667 8.35556 11.2083 8.83056 11.525 9.425C11.8417 10.0194 12 10.6556 12 11.3333V13.3333H13.3333V14.6667H2.66667Z",
    fill: "#5987D1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg858Ab);
export default __webpack_public_path__ + "static/media/858ab.07a29a712a0a2aa8cf564289b5bd9e1f.svg";
export { ForwardRef as ReactComponent };